export default __webpack_public_path__ + "static/media/Ellipse.0b8c0379.svg";